import companies from './companies';


export default function* () {
    yield* [...companies];
}
